import { render, staticRenderFns } from "./ActivityHistory.vue?vue&type=template&id=56e00b71&"
import script from "./ActivityHistory.vue?vue&type=script&lang=js&"
export * from "./ActivityHistory.vue?vue&type=script&lang=js&"
import style0 from "./ActivityHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports